import React from 'react'

import CreateUserType from '../../../../components/CreateUserType'
import ContextMenu from '../../../../components/ContextMenu'

export default function () {
  return (
    <div className='container'>
      <ContextMenu renderTitle={() => <h1 className='title'>Create a new user type</h1>}></ContextMenu>
      <CreateUserType />
    </div>
  )
}
